import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem('token');
    if (token) {
      fetchUserData(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserData = async (token) => {
    try {
      console.log('Fetching user data with token:', token); // Debug log
      const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const userData = await response.json();
        console.log('User data received:', userData); // Debug log
        setUser(userData);
      } else {
        console.log('Failed to fetch user data:', response.status); // Debug log
        localStorage.removeItem('token');
        setUser(null);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      localStorage.removeItem('token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };


  const login = async (email, password) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();
      console.log('Login response:', data); // Debug log
      
      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      localStorage.setItem('token', data.token);
      setUser(data.business);
      return data;
    } catch (error) {
      console.error('Login error:', error); // Debug log
      throw new Error(error.message || 'Login failed');
    }
  };


  const register = async (userData) => {
    const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userData)
    });
  
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Registration failed');
    }
  
    // Store token and user data
    localStorage.setItem('token', data.token);
    setUser({
      id: data.business.id,
      businessName: data.business.businessName,
      email: data.business.email,
      apiKey: data.business.apiKey
    });
  
    return {
      token: data.token,
      user: data.business
    };
  };
  
  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };
  console.log('Current user state:', user);
  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      register,
      logout
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};